import styled, { keyframes } from 'styled-components';

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateY(-80px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  width: 100%;
  height: calc(100vh - 140px);
  /* background-color: #cecece; */
`;

export const Content = styled.div`
  display: grid;
  place-items: center;
  height: 100%;

  > img {
    max-width: 80%;
    height: 100%;

    animation: ${appearFromLeft} 0.7s;
  }
`;


export const HeaderPonto = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding-bottom: 1.5rem;
  justify-content: space-between;

  .titlePonto {
    font-size: 1.5rem;
    color: #413F3F;
  }
`;

export const HeaderPontoSecond = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding-bottom: 1.5rem;
  padding-top: 1.5rem;
  justify-content: space-between;

  .titlePonto {
    font-size: 1.5rem;
    color: #413F3F;
  }
`;

export const SectionPanel = styled.div`
  align-items: flex-start;
  margin-top:1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50%, 1fr));
  
`;

export const HalfPanel = styled.div`
  display: flex;
  flex-direction: column;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  padding-left: 0;
  :last-child{
    padding-right: 0;
  }

  table.default{
        width: 100%;
        border-collapse: collapse;
        tr {
            position: relative;
            th {
                white-space: nowrap;
            }
            th, td {
                padding: 20px;
                &.sm{
                    width: 100px;
                    max-width: 100px;
                    text-align: center;
                }
                &.center{
                    text-align: center;
                }
            }
            th {
                color: var(--font);
                text-align: left;
            }
            td {
                border-bottom: 1px solid #eee;

                background-color: #fff;
                &:first-child{
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                }
            }
            &:hover{
                td{
                    opacity: 1;
                }
            }
        }
        .btn{
            margin: 0;
            padding: 0;
            svg{
                width: 18px;
                height: 18px;
                transition: .2s;
                &:hover{
                    transform: scale(1.4) rotate(180deg);
                }
            }
        }
    }
    div.table-scroll {
        width: 100%;
        overflow: auto;
        td > .order {  
            text-align: center;
            padding: 15px 20px;
            border-radius: 8px;
            background: #d8d8d8;
        }
    }
    div.content{
        max-width: 600px;
        padding: 20px;
        background-color: #fff;
        position: relative;
        .subtitle{
            font-size: 100%;
        }
    }
    div.actions{

        display: flex;
        .btn{
            box-sizing: border-box;
            max-width: 200px;
            margin-right: 15px;
        }
    }
`;

export const SectionFilterPonto = styled.div`
  align-items: center;
  margin-top:1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20%, 1fr));

  div.card-saldo{
    display: flex;
    flex-direction: column;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    color:#fff;
    font-size: 18px;
    font-weight: 800;
    border-radius: 5px;
    margin-right: 1rem;
    div.progress{
      overflow: hidden;
      height: 8px;
      margin-top: 0.8rem;
      border-radius: .25rem;
      background-color: #e9ecef;
      box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
      div.progress-bar{
        height: auto;
        border-radius: 0;
        box-shadow: none;
        background-color: #1f875b;
        height: 8px;
      }
    }
    div{
      width: 100%;
      
      }
    }
  
  div.total{
    background:linear-gradient(87deg,#5e72e4 0,#825ee4 100%)!important
  }
  div.total{
    background:linear-gradient(87deg,#5e72e4 0,#825ee4 100%)!important
  }
  div.tropa{
    background: linear-gradient(87deg,#f5365c 0,#f56036 100%)!important;
  }
  div.deco{
    background: linear-gradient(87deg,#11cdef 0,#1171ef 100%)!important;
  }
  div.gui{
    background:linear-gradient(87deg, #000000ab 0, #ff00009e 100%) !important;
    margin-right: 0;
  }
  div.kaique{
    background:linear-gradient(87deg, #1f875b 0, #1bff0099 100%) !important;
  }
  
    
`;



export const SectionTablePonto = styled.div`
  display: flex;
  width:100%;
  background-color: #fff;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`;

export const ContainerPonto = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 900px;

  height: calc(100vh - 100px);
  overflow-y: scroll;
  padding-right: 6px;

  ::-webkit-scrollbar {
    display: none;
  }

  .buttonClosePreview {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      position: fixed;
      bottom: -40px;
      left: 40%;

      padding: 4px 12px;
      gap: 10px;

      line-height: 1rem;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      background-color: transparent;
      border: none;

      transition: all 0.35s;
      &:hover {
          transform: scale(1.1);
      }
    }`;

export const SectionDetailsPonto = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  background-color: #FFFF;
  border-radius: 5px;
  padding: 2rem 2.2rem;

  > h1 {
    font-size: 1.125rem;
    color: var(--title);
    border: none;
  }

  .fieldGroupPonto {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;

    .fieldPonto {
      display: flex;
      flex-direction: column;
      gap: 4px;

      >h3 {
        font-size: 14px;
        font-weight: 500;
        color: var(--font);
      }

      >h4 {
        font-size: 1rem;
        font-weight: 600;
        color: var(--primary);
      }
    }
  }
`;

export const SectionRegisterPonto = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  background-color: #FFFF;
  border-radius: 5px;
  padding: 2rem 2.2rem;

  .headerModalPonto {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 20px;

    > h2 {
      margin-bottom: 4px;
    }
  }

  .dataPonto {
    display: grid;
    grid-template-columns: 300px 1fr;
    gap: 2rem;

    .sectionImagePonto {

      > h3 {
        font-size: 14px;
        font-weight: 500;
        color: var(--font);
        margin-bottom: 12px;
      }

      display: flex;
      flex-direction: column;
      border-radius: 8px;
      object-fit: cover;
      width: 100%;
      height: 100%;

      img {
        border-radius: 8px;
        width: 100%;
        height: 200px;
        object-fit: cover;
      }
    }

    .sectionInfoPonto {

      .fieldGroupPontoHeader {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(6rem, 1fr));
        gap: 1.5rem;
        margin-bottom: 1.5rem;
        border-bottom: 1px solid #DBDBDB;
        padding-bottom: 1.5rem;

        .fieldPonto {
          >h3 {
            font-size: 14px;
            font-weight: 500;
            color: var(--font);
          }

          >h4 {
            font-size: 1rem;
            font-weight: 600;
            color: var(--title);
          }
        }
      }

      .fieldGroupPonto {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(6rem, 1fr));
        gap: 1.5rem;
        margin-bottom: 1.5rem;

        .fieldPonto {
          >h3 {
            font-size: 14px;
            font-weight: 500;
            color: var(--font);
          }

          >h4 {
            font-size: 1rem;
            font-weight: 600;
            color: var(--title);
          }
        }
      }
    }
  }


`;